import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  SystemSettingssByKeyDocument,
  SystemSettingssDocument,
  type SystemSettingssQuery,
} from '@/graphql/generated/graphql';

export type SystemSettingItem = NonNullable<
  NonNullable<SystemSettingssQuery['getSystemSettingss']>['items']
>[number];
export type GetSystemSettingsResponse = SystemSettingssQuery;

export const toSystemSettingsRequest = (
  params?: ListQueryVariables<Record<string, unknown>> | null
) => {
  const { where, paging } = toListQueryVariables(params);
  const pageNo = paging.pageNo;
  const pageSize = paging.pageSize;
  const key = eqFromWhere(where, 'Key');
  if (key) {
    return { document: SystemSettingssByKeyDocument, variables: { key, pageNo, pageSize } };
  }
  return { document: SystemSettingssDocument, variables: { pageNo, pageSize } };
};

export const useGetSystemSettings = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const request = toSystemSettingsRequest(params);
  return useQuery({
    queryKey: ['system-settings', request.variables],
    queryFn: () => graphqlClient.request(request.document, request.variables),
  });
};

export const requestSystemSettings = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const request = toSystemSettingsRequest(params);
  return graphqlClient.request(request.document, request.variables);
};

export const requestSystemSettingByKey = async (key: string) => {
  const data = await requestSystemSettings({
    where: { Key: { eq: key } },
    paging: { pageNo: 1, pageSize: 1 },
  });
  return data.getSystemSettingss?.items?.[0] ?? null;
};

export const GET_SYSTEM_SETTINGS_QUERY = SystemSettingssDocument;
export const GET_SYSTEM_SETTINGS_BY_KEY_QUERY = SystemSettingssByKeyDocument;
